import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import Cookies from 'js-cookie';

/**
 * Componente que maneja la ruta raíz /mispagos
 * - Si tiene token de cliente → muestra dashboard
 * - Si no tiene token → muestra login
 */
const ClientePortalRedirect = () => {
  const { tenant } = useParams();
  const token = localStorage.getItem('clienteToken');
  const tenantActual = tenant || Cookies.get('tenantURL') || 'tours';

  // Si tiene token, redirigir a dashboard
  if (token) {
    return <Navigate to={`/${tenantActual}/mispagos/dashboard`} replace />;
  }

  // Si no tiene token, mostrar login
  return <Navigate to={`/${tenantActual}/mispagos/login`} replace />;
};

export default ClientePortalRedirect;
